import { render, staticRenderFns } from "./framework-loader.vue?vue&type=template&id=785ab006&scoped=true&"
import script from "./framework-loader.vue?vue&type=script&lang=js&"
export * from "./framework-loader.vue?vue&type=script&lang=js&"
import style0 from "./framework-loader.vue?vue&type=style&index=0&id=785ab006&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "785ab006",
  null
  
)

export default component.exports